import React from 'react';
import TablaReversionMovimientosCV from './controladorVista/tablaReversionMovimientosCV';

const ReversionMovimientos: React.FunctionComponent = () => <TablaReversionMovimientosCV />;

export default ReversionMovimientos;
